import { render, staticRenderFns } from "./ShowOrders.vue?vue&type=template&id=1b989116&lang=pug"
import script from "./ShowOrders.vue?vue&type=script&lang=js"
export * from "./ShowOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports